import { createAsyncAction } from "typesafe-actions";
import Coupon from "../../models/coupon/Coupon";
import { SearchCouponsRequest } from "../../models/tariff/SearchCouponsRequest";
import { TrafficArea } from "../../models/tariff/trafficAreas/TrafficArea";
import { TrafficAreaGeography } from "../../models/tariff/trafficAreas/TrafficAreaGeography";
import { GetTrafficAreasActionTypes, GetTrafficAreasGeographyActionTypes, SearchCouponsActionTypes } from "./types";

export const searchCouponsActions = createAsyncAction(
    SearchCouponsActionTypes.REQUEST,
    SearchCouponsActionTypes.SUCCESS,
    SearchCouponsActionTypes.ERROR
)<SearchCouponsRequest, Coupon[], undefined>();

export const getTrafficAreasActions = createAsyncAction(
    GetTrafficAreasActionTypes.REQUEST,
    GetTrafficAreasActionTypes.SUCCESS,
    GetTrafficAreasActionTypes.ERROR
)<undefined, TrafficArea[], undefined>();

export const getTrafficAreasGeographyActions = createAsyncAction(
    GetTrafficAreasGeographyActionTypes.REQUEST,
    GetTrafficAreasGeographyActionTypes.SUCCESS,
    GetTrafficAreasGeographyActionTypes.ERROR
)<undefined, TrafficAreaGeography[], undefined>();
